export interface BulletList {
  bullets: string[];
}

/** Returns whether bullet lists have equal lengths and matching values, regardless of order. */
export default function checkBulletListsAreSame(array: BulletList[]) {
  return array.every((curr) =>
    array.every(
      (object) =>
        object.bullets.length === curr.bullets.length &&
        curr.bullets.every((point) => object.bullets.includes(point))
    )
  );
}
